<template>
    <div class="modelList_box">
        <div class="app_container">
            <div class="modelList_header">
                <ul class="modelList_items">
                    <li class="modelList_item" v-for="(topo,index) in showList" v-bind:key="index">
                        <div class="modelList_thumbnails topo_img_box" v-bind:style="{backgroundImage:'url('+ topo.icon1 +')'}" v-on:click="viewTopo(topo,index,true)" title="预览拓扑">
                        <!-- <div class="modelList_thumbnails topo_img_box" v-bind:style="{backgroundImage:'url(https://topo.thingjs.com/thing-api/resource/static'+ topo.icon1 +'),url(../../static/img/scene-default1.png)'}" v-on:click="viewTopo(topo,index,true)" title="预览拓扑"> -->
                            <div class="top_left tooltip-box top" data-content="推荐项目" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" style="background: #f5a726;">
                                <img src="../../static/img/project.svg" style="width:16px;height:16px"/>
                            </div>
                            <span class="indexAPP" @click.stop="viewTopo"><i>{{index+1}}</i></span>
                            <!-- <div id="model_keyword">
                                <ul>
                                    <li v-html="$options.filters.highLightkeyWord(keyword)" v-if="$options.filters.highLightkeyWord(keyword)" v-for="(keyword) in city.keyWordArr" v-bind:key="keyword">{{keyword}}</li>
                                </ul>
                            </div> -->
                            <!-- <div class="isPay" @click.stop="saleItem(topo)">使用</div> -->
                        </div>
                        <hr/>
                        <div class="modelList_info projectList_info">
                            <div class="author_info city_author_info">
                                <a class="tooltip-box top" style = "cursor:auto">
                                    <img class="author_headImg" src="../../static/img/topo.png">
                                </a>
                                <span class="author_name" style="max-width:200px;" v-on:click="viewTopo(topo,index)" v-html="$options.filters.highLightMsg(topo.name)" v-bind:title="topo.name" @dblclick="selectText()">{{topo.name}}</span>
                            </div>
                            <div class="model_info">
                                <div class="model_seen model_time tooltip-box top"  v-bind:data-content="processingTime(topo.createTime)" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-calendar fa-fw"></i>
                                </div>
                                <div class="model_price tooltip-box top" data-content="拓扑售价" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-yen fa-fw"></i>{{topo.price}}
                                </div>
                                <!-- <div class="model_seen tooltip-box top" data-content="数据大小" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-file-archive-o"></i>{{formatBytes(topo.projectSize)}}
                                </div> -->
                                <div class="model_seen tooltip-box top" data-content="浏览次数" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-eye fa-fw"></i>{{formatNumber(topo.view)}}
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="modelList_footer">
                <h4 class="text_muted" v-if="!isLoadComplete">加载中...</h4>
				<div class="load_more_btn" v-on:click="loadMore" v-if="!isLastPage&&isLoadComplete">加载更多<i class="fa fa-arrow-circle-o-down"></i></div>
				<h4 v-if="isLastPage" class="text_muted">已显示全部</h4>
			</div>
        </div>
    </div>
</template>
<script>
    import bus from '../assets/js/eventBus.js';
    import crypto from 'crypto-browserify';
    import Identicon from 'identicon.js';
    import shield from '../assets/js/shield.js';
    var vm;
    export default {
        name:"topo_box",
        components:{},
        data:function(){
            return {
                Path: "https://www.thingjs.com/citybuilder_console/",
                viewPath:"https://www.thingjs.com/citybuilder/#/projectPreview?model=preview&logo=false&template=false",
                imgPath : "https://www.thingjs.com",
                copyPath:"https://www.thingjs.com",
                showList:[],
                queryData: {
                    type:"",
                    bigType: "",
                    smallType: "",
                    keyWord: "",
                    pageSize: 24,
                    pageNumber: 1,
                    sort: "zonghe"
                },
                isLastPage:false,
                message:[],
                infoShow:false,
                topoListNum:'',
                index:0,
                isLoadComplete :false,
                panelShow:false,
                openUrl:''
            };
        },
        methods:{
            selectText(){
                document.getSelection().selectAllChildren(document.getSelection().focusNode.parentNode);
                document.execCommand('copy');
            },
            disposeUrl:function(url,userNick){
                if(!!url){
                    var urlHeader = url.substring(0,4);
                    if(urlHeader == 'http'){
                        return url;
                    }else{
                        return this.imgPath + url;
                    }
                }else{
                    if(userNick == null){
                        userNick = 'thingjs';
                    }
                    var hash = crypto.createHash('md5');
                    hash.update(userNick);
                    var imgData = new Identicon(hash.digest('hex')).toString();
                    var imgUrl = 'data:image/png;base64,'+imgData;
                    return imgUrl;
                return imgUrl;
                    return imgUrl;
                }
            },
            formatBytes:function(bytes, decimals) {
                if (bytes === 0) return ' -- ';
                var k = 1024;
                var dm = decimals < 0 ? 0 : decimals;
                var sizes = ['B', 'K', 'M', 'G', 'T', 'PB', 'EB', 'ZB', 'YB'];
                var i = Math.floor(Math.log(bytes) / Math.log(k));
                return ' ' + parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + sizes[i];
            },
            queryTopolList:function(data){
                var _this = this;
                var _list = this.showList;
                _this.isLoadComplete = true;
                this.$reqs.post("/scene/topo", data).then(function(result) {
                    if(result && result.data.state) {
                        var content = result.data.content;
                        var contentLen = content.length;
                        bus.$emit('changeListCount',result.data.recordCount);
                        _this.topoListNum = result.data.recordCount;
                        for(var i = 0; i < contentLen; i++) {
                            _list.push(content[i]);
                        }
                        // console.log(_list);
                        _this.isLastPage = result.data.recordCount <= result.data.pageNumber*result.data.pageSize;
                    }else{
                        console.log('queryTopoList error');
                    }
                }).catch(function(error) {
                    console.log('queryTopoList error'+error);
                });
            },
            showTooltip: function(event) {
                var content = $(event.target).data("content");
                var tipEle ='<div class="tooltips"><div class="arrow"></div>' + content +'</div>';
                $(event.target).append(tipEle);
            },
            cancelTooltip: function(event) {
                $("div").remove(".tooltips");
            },
            showTooltip1: function(event) {
                var content = $(event.target).data("content");
                var tipEle ='<div class="tooltips"><div class="arrow"></div>' + content +'</div>';
                $(event.target).append(tipEle);
                var leftPx = Number('-' + parseInt($('.tooltips').width())/2);
                $('.modelList_info .city_author_info .top .tooltips').css({
                    "left":leftPx,
                    "transition-duration":"0s"
                });
            },
            cancelTooltip1: function(event) {
                $("div").remove(".tooltips");
                $('.modelList_info .city_author_info .top .tooltips').css({
                    "left":"0px",
                    "transition-duration":"0s"
                });
            },
            formatNumber: function(number) {
                if(number < 1000) {
                    return number;
                } else {
                    return(number / 1000).toFixed(1) + "k";
                }
            },
            loadMore: function() {
                this.queryData.pageNumber++;
                this.queryTopolList(this.queryData);
            },
            processingUrl:function(path){
                var backPath = path.toString().replace(/\\/g, "/");
                return this.Path+backPath;
            },
            processingTime: function(time) {
                // const isDateTime = new Date(time);
                // const year = isDateTime.getFullYear();
                // const month = String(isDateTime.getMonth() + 1).padStart(2, '0');
                // const day = String(isDateTime.getDate()).padStart(2, '0');
                // const hours = String(isDateTime.getHours()).padStart(2, '0');
                // const minutes = String(isDateTime.getMinutes()).padStart(2, '0');
                // const seconds = String(isDateTime.getSeconds()).padStart(2, '0');
                // var dateStr = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
                // return dateStr;
                var str = time.toString();
                var year = str.substring(0,4);
                var mon = str.substring(4,6);
                var day = str.substring(6,8);
                var hour = str.substring(8,10);
                var min = str.substring(10,12);
                var sec = str.substring(12,14);
                var dateStr = year + '-' + mon + '-' + day + ' ' + hour + ':' + min + ':' + sec;
                return dateStr;
            },
            zoomdiv:function(){
                let zoomicon = document.getElementsByClassName('zoom_icon')[0];
                let listInfo = document.getElementById('list_info');
                let infoBottom = document.getElementById('info_bottom');
                if(zoomicon.alt == "shrink"){
                    listInfo.className = 'modelList_infoShow cityShow';
                    infoBottom.className = 'info_bottom';
                    $('.kefuBtn').show();
                    $('.qqBtn').show();
                    $('.wxBtn').show();
                    zoomicon.src = "../../static/img/最大化.png";
                    zoomicon.alt = "maximize";
                }else if(zoomicon.alt == "maximize"){
                    listInfo.className = 'modelList_infoShow_max cityShow';
                    infoBottom.className = 'info_bottom_max';
                    $('.kefuBtn').hide();
                    $('.qqBtn').hide();
                    $('.wxBtn').hide();
                    zoomicon.src = "../../static/img/最小化.png";
                    zoomicon.alt = "shrink";
                }
            },
            closediv:function(){
                $('.kefuBtn').show();
                $('.qqBtn').show();
                $('.wxBtn').show();
                if($(".fullScreen").hasClass("tuichu")){
                    this.large();
                }
                this.infoShow = false;
            },
            viewTopo:function(topo,index,flag){
                // console.log(topo.attributeStore);
                var _this = this;
                let _data = {
                    id: topo.id,
                    iid: topo.iid
                }
                if($.cookie('openid')){
                    var openUrl= 'https://topo.thingjs.com/#/thingtopo/view/'+topo.encryptId;
                    window.open(openUrl,"_blank");
                    _this.$reqs.post("/project/updateTopoView", _data).then(function(result) {})
                }else{
                    logoinForStore();
                }
            },
            large:function(){
                var _this = this;
                var parentF = '';
                var id = '';
                parentF = ".modelList_infoShow";
                id = "#myframeC";
                if($(".fullScreen").hasClass("tuichu")){
                    $(parentF).removeClass("quanping");
                    $(id).removeClass("fullFrame");
                    $(".fullScreen").removeClass("tuichu");
                    $("html").css("overflow-y","scroll");
                    $(".popContainer").show();
                    $(".fullScreenClose").hide();
                    // $('.navHeader').hide();
                }else{
                    $(".fullScreen").addClass("tuichu");
                    $(parentF).addClass("quanping");
                    $(id).addClass("fullFrame");
                    $("html").css("overflow-y","hidden");
                    $(".fullScreenClose").show();
                    $(".popContainer").hide();
                    $('.navHeader').show();
                }
            },
            saleItem(topo,flag = true) {
                var _this = this;
                // if(flag){
                //     var msg = {title:"购买项目",subject:'project_buy_city',toolInfo:{data:topo}};
                //     console.log('msg: ', msg);
                //     bus.$emit('view',msg);
                //     return
                // }
                if($.cookie('openid')){
                    _this.copyPath = 'http://store.thingjs.com:84';
                    $.ajax({
                        url:_this.copyPath+'/api/sample/sen_resource/topo/copy',
                        type:'post',
                        dataType:'json',
                        xhrFields: {withCredentials: true},
                        crossDomain: true,
                        data: { "id": topo.encryptId, "name": encodeURIComponent(topo.name) },
                        success: function (res) {
                            console.log("复制成功！");
                        },
                        error: function (err) {
                            console.log('err: ', err);
                            console.log("复制失败！");
                        }
                    })
                }else{
                    logoinForStore();
                }
            },
            hidePanel:function(success) {
                var _this = this;
                this.panelShow = false;
            },
        },
        beforeCreate() {
            vm = this;
        },
        beforeDestroy(){
            bus.$off("addTopoList");
            bus.$off("changeTopoList");
            bus.$off("showTopoNull");
        },
        mounted(){
            var _this = this;
            if(shield.shieldWords.indexOf($("#keyword").val())=='-1'){
                this.queryData.keyWord = $("#keyword").val();
            }
            this.queryData.sort = $('.active').attr('data-sort');
            this.queryTopolList(this.queryData);
            bus.$on("changeTopoList",(data) =>{
                this.showList = [];
                this.queryTopolList(data);
                this.queryData = JSON.parse(JSON.stringify(data));
            });
            bus.$on("showTopoNull",(data) =>{
                this.showList = [];
                bus.$emit('changeListCount','-1');
                this.isLastPage = true;
            });
            bus.$on("addTopoList", (data) => {
                _this.queryData.pageNumber++;
                this.queryTopolList(_this.queryData);
            });
            // city.vue
            bus.$on("project_buy_city",(data) => {
                this.saleItem(data,false);
            })
        },
        filters:{
            highLightMsg:function(value){
                if(vm.queryData && vm.queryData.keyWord){
                    var reg = new RegExp(vm.queryData.keyWord,"g");
                    if(value.indexOf(vm.queryData.keyWord) != -1){
                        return value.replace(reg,'<span class="highlight">'+vm.queryData.keyWord+'</span>')
                    }else{
                        return value;
                    }
                }else{
                    return value;
                }
            },
            highLightkeyWord:function(value){
                if(vm.queryData && vm.queryData.keyWord){
                    var reg = new RegExp(vm.queryData.keyWord,"g");
                    if(value.indexOf(vm.queryData.keyWord) != -1){
                        return value.replace(reg,'<span class="highlight">'+vm.queryData.keyWord+'</span>')
                    }else{
                        return false;
                    }
                }else{
                    return false;
                }
            }
        }
    }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Topos.vue